import type { ReactNode } from "react";
import type { ProfileSectionUserMenuProps } from "./ProfileSectionUserMenu";
import { ProfileSectionUserMenu } from "./ProfileSectionUserMenu";
import { ProfileSectionWrapper } from "./ProfileSectionWrapper";

export interface ProfileSectionViewProps extends ProfileSectionUserMenuProps {
  children: ReactNode;
  className?: string;
}

export const ProfileSectionView = ({
  headline = "",
  imageUrl = "",
  name = "",
  onEditProfileClick,
  onSignOutClick,
  publicUid = "",
  showMemberBilling = false,
  canAccessAuthenticationPage = false,
  canShowPaywallsAffiliate = false,
  children,
  className,
}: ProfileSectionViewProps) => (
  <ProfileSectionWrapper className={className}>
    <ProfileSectionUserMenu
      headline={headline}
      imageUrl={imageUrl}
      name={name}
      onEditProfileClick={onEditProfileClick}
      onSignOutClick={onSignOutClick}
      publicUid={publicUid}
      showMemberBilling={showMemberBilling}
      canAccessAuthenticationPage={canAccessAuthenticationPage}
      canShowPaywallsAffiliate={canShowPaywallsAffiliate}
    />
    {children}
  </ProfileSectionWrapper>
);
